<template>
  <modal :show="show" @change="$emit('change',$event)" width="700">
    <template v-slot:header>
      <span>{{subscribe?'Отключение':'Подключение'}} услуги "Электронный ЕПД"</span>
    </template>
    <template v-slot:main>
      <div class="modal-info text-left mx-7">
        <span class="d-block helvetica-medium my-4">Уважаемый клиент!</span>
        <span class="d-block">
          В этом разделе Вы можете подключить или отключить услугу "Электронный единый платежный документ"
        </span>
        <span class="d-block helvetica-medium my-4">Лицевой счёт:</span>
        <loader-wrapper :loading="loading" :opacity="0.5">
          <v-form ref="form" v-model="validForm">
            <personal-account-select :only-is-owner="true" v-model="selectedAccount" :is-local="true"/>
            <v-text-field
              :value="userSettings.email"
              outlined
              readonly
              label="Email"
            >
              <template v-slot:append>
                <v-tooltip right max-width="300" nudge-right="10">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="#ff721c" class="cursor_pointer">mdi-help-circle-outline</v-icon>
                  </template>
                  <span>{{emailHelp}}</span>
                </v-tooltip>
              </template>
            </v-text-field>

            <v-select
              class="personal-account-select"
              item-value='phoneNumber'
              item-text='phoneNumber'
              :items="activeActualPhones"
              outlined
              label="Номер телефона"
              v-model="phone"
              :rules="phoneNumberRules"
            >
            </v-select>

            <v-checkbox
              v-if="!subscribe"
              color="#ff721c"
              class="tes-agreement-checkbox"
              :label="agreementText"
              v-model="agreement"
              :rules="agreementRules"
            >
            </v-checkbox>
          </v-form>
        </loader-wrapper>
        <div class="pt-3 pb-6 text-center">
          <v-btn class="inline-block outlined-transparent-button" width="150" @click="clearForm" :disabled="loading">
            Отмена
          </v-btn>
          <v-btn class="inline-block blue-button mx-5" width="150" @click="showPreview"
                 :disabled="!subscribe && (!agreement || loading)">Предпросмотр
          </v-btn>
          <v-btn class="inline-block green-button" width="150" @click="subscribe" :disabled="loading">
            {{subscribe? 'Отключить':'Подключить'}}
          </v-btn>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
  import Modal from '../common/Modal'
  import PersonalAccountSelect from '../common/PersonalAccountSelect'
  import { mapGetters, mapState } from 'vuex'
  import LoaderWrapper from '../common/LoaderWrapper'

  export default {
    name: 'ModalSpd',
    components: {LoaderWrapper, PersonalAccountSelect, Modal},
    model: {
      prop: 'show',
      event: 'change'
    },
    props: {
      show: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      selectedAccount: null,
      phone: null,
      agreement: false,
      loading: false,
      validForm: false,
      phoneNumberRules: [v => !!v || 'Выберите номер телефона'],
      agreementRules: [v => !!v || 'Необходимо принять условия'],
      agreementText: 'Я согласен получать электронный единый платежный документ по электронной почте и ' +
      'отказаться от получения единого платежного документа в бумажном виде',
      emailHelp: '«Изменить или ввести новый адрес электронной почты или телефонный номер вы можете на странице' +
      ' «Контактные данные» в меню «Настройки»',
    }),
    computed: {
      ...mapState('account', ['accounts', 'actualPhones', 'userSettings']),
      ...mapState('statements', ['subscription']),
      ...mapGetters('account', ['activeActualPhones']),
      title () {
        return `Заявление на ${this.subscription === true ? 'отключение' : 'подключение'} услуги «Электронный ЕПД»`
      }
    },
    watch: {
      selectedAccount (val) {
        this.loading = true
        if (val) this.$store.dispatch('statements/checkSubscription', {domHoz: val.domHoz}).finally(() => {
          this.loading = false
        })
      }
    },
    methods: {
      clearForm () {
        this.phone = null
        this.agreement = false
      },
      subscribe () {
        if (!!this.$refs.form.validate()) {
          this.loading = true
          this.$store
            .dispatch('statements/toggleElectronicReceipt', {
              domhoz: this.selectedAccount.domHoz,
              check: !this.subscription,
              phone: this.phone
            })
            .then(() => {
              this.clearForm()
              this.$emit('change', false)
            }).finally(() => {
            this.loading = false
          })
        }
      },
      showPreview () {
        this.loading = true
        this.$store
          .dispatch('statements/getElectronicReceiptView', {check: this.subscription})
          .then((response) => {
            let key = (new Date()).toTimeString()
            localStorage.setItem(key, response)
            let routeData = this.$router.resolve({
              path: '/preview',
              query: {
                title: this.title,
                key
              }
            })

            window.open(routeData.href, '_blank')
          }).finally(() => {
          this.loading = false
        })
      }
    },
    created () {
      this.loading = true
      this.$store.dispatch('account/getActualPhones').finally(() => {
        this.loading = false
      })

    }
  }
</script>

<style scoped lang="scss">
  .modal-info {
    min-height: 200px;
    //display: flex;
    //flex-direction: column;

    &__message {
      margin: auto;
    }
  }
</style>
